// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__D0+c4","text":"Contact_text__Lh7lp","links":"Contact_links__f1bmP","link":"Contact_link__bZZWa"};